import { useIsElectron } from "../../imports";
import { socketActions } from "../../imports";

export default function OpenExternal({
	buttonText,
	isElectronLink,
	isNotElectronLink,
	className = '',
}) {
	const isElectron = useIsElectron();

	return (
		<button
			onClick={() => {
				if (isElectron) return socketActions.visitExternal(isElectronLink);

				return window.open(isNotElectronLink, "_blank");
			}}
			className={[
				"text-xs underline text-left text-gray-500 hover:text-gray-400 focus:outline-none focus:ring",
				className
			].join(' ')}
		>
			{buttonText}
		</button>
	);
}
